import {
    SET_LEAD_NOTES_REDUCER,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE,
} from '../constants/get_lead_profile.constants';
import {
    ADD_LEADS_NOTE_REQUEST,
    ADD_LEADS_NOTE_REQUEST_SUCCESS,
    ADD_LEADS_NOTE_REQUEST_FAILURE,
} from '../constants/add_note.constants';


const initialState = {
    loading: false,
    notes: [],
    error: null,
};

export const Lead_notes = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_NOTES_DATA':
        return {
            ...state,
            ...action.payload,
        };
    case SET_LEAD_NOTES_REDUCER:
        return {
            ...state,
            notes: action.payload,
        };

    case GET_LEADS_PROFILE_WITH_NOTES_REQUEST:
        return {
            ...state,
            notes: [],
        };

    case GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS:
        return {
            ...state,
            notes: action.payload,
        };
    case ADD_LEADS_NOTE_REQUEST:
        return {
            ...state,
            loading: true,
            notes: [],
        };
    case ADD_LEADS_NOTE_REQUEST_SUCCESS:
        return {
            ...state,
            notes: action.payload,
            loading: false,
        };
    case GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE:
    case ADD_LEADS_NOTE_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            notes: [],
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_notes.reducer.js